import nfetch from "@/utils/events/nfetch";

import { IServiceAnexo } from "./base/iServiceAnexo";

export default class ProdutoAnexoService extends IServiceAnexo {
    constructor() {
        super("ProdutoAnexo");
    }

    public insertFileComProdutoLote(
        id: number,
        descricao: string,
        produtoLoteId: number,
        file: File,
    ): Promise<Response> {
        const data = new FormData();
        const ext = file.getExtension();
        data.append("file", file, file.name);
        const produtoLoteParam = produtoLoteId ? `&produtoLoteId=${produtoLoteId}` : "";
        return nfetch(
            `/${this.controllerName}/InsertComProdutoLote?id=${id}&descricao=${descricao}&extensao=${ext}${produtoLoteParam}`,
            {
                method: "post",
                credentials: "same-origin",
                body: data,
            },
        );
    }
}

